import React, { Component } from "react";
import {
  Collapse,
  Navbar as BootstrapNavbar,
  NavbarToggler,
  Nav,
  NavItem
} from "reactstrap";
import { Link } from "react-router-dom";

import logo from "../assets/images/logo.png";

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <BootstrapNavbar color="dark" dark expand="md">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="ElProfeShop logo" height="30" width="146.89" />
          </Link>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem onClick={window.innerWidth > 768 ? null : this.toggle}>
                <Link className="nav-link" to="/suggestions/new">
                  Sugerir Profe
                </Link>
              </NavItem>
              <NavItem onClick={window.innerWidth > 768 ? null : this.toggle}>
                <Link className="nav-link" to="/contactus">
                  Contact Us
                </Link>
              </NavItem>
            </Nav>
          </Collapse>
        </div>
      </BootstrapNavbar>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js